<template>
  <div>
    <ul class="nav nav-tabs">
      <li v-for="(item, key) in data" :key="key" :class="{ 'active': currentTab === item.id }" @click="handleChangeTab(item.id)">
        <a>{{ item.title }}</a>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    currentTab: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loader: null
    }
  },
  methods: {
    handleChangeTab (id) {
      if (this.currentTab === id) return false

      this.$router.push({
        name: 'Premium',
        params: {
          tab: id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/premium/components/NavTabs.vue